import { useLiveCollaborationNotes } from '~publish/hooks/notes/useLiveCollaborationNotes'

export function LiveCollaborationNotes(): null {
  useLiveCollaborationNotes()
  return null
}
